<script>
	/*import AdvancedBoard from '../assets/board-advanced.png';
	import BasicBoard from '$lib/assets/board-basic.png';*/
	//import ImageDownload from './ImageDownload.svelte';

	import { ui, state, live } from "../../stores";
	import { checkMission } from '../../parse';
    import OperationsSection from "../ops/OperationsSection.svelte";
    import OperationsSectionContent from "../ops/OperationsSectionContent.svelte";
    import { possArray } from "../../card_actions";

	export let deck;
	export let side;
	export let hideSideLabel = false;
	export let preview;
	export let p;
	export let special; 
	export let customImage = false;
	let isAdvanced;
	let bgSrc;

	$: isAdvanced = side === 'advanced';
	$: bgSrc = customImage || `./assets/board-${side}.png`;

	let boardEl;

	function previewClass(preview, area){
		if(!preview) return '';
		if(p.captain == 'Borg Queen') return 'borg_preview';
		if(area == 'mission'){
			return 'mission_preview';
		}else{
			return 'track_preview';
		}
	}

	let fullPreviewCaptains = ['Borg Queen', 'Q']
	
</script>

<div class="board flex-div" class:selected={$ui.dashboardSelected == p && !preview}  bind:this={boardEl}
>
	<img class="board-bg {previewClass(preview, $live.dashboardArea)}" src={bgSrc} alt="{deck}-{side}-board" />
	{#if !preview || fullPreviewCaptains.includes(p.captain) ||  $live.dashboardArea == 'mission'}
		{#if !hideSideLabel}
			<div class="side-label glow-label font-block">{side.toUpperCase()}</div>
		{/if}
		<div class="deck-label glow-label font-block">{deck.toUpperCase()}</div>
		<div class="mission-container">
			<slot name="missions" />
		</div>
		{#if special}
			<div class="special-container mission">
				<OperationsSection type="special" let:labelColor let:textColor>
						<OperationsSectionContent operations={[special]} {labelColor} {textColor} />
				</OperationsSection>
			</div>
		{/if}
	{/if}
	{#if !preview || fullPreviewCaptains.includes(p.captain) || $live.dashboardArea != 'mission'}
		<slot name="tracks" />
	{/if}
	<!--<ImageDownload {deck} {side} element={boardEl} />-->
</div>

<style lang="scss">
	.selected {
        border: 5px dashed orange;
        filter: saturate(3);
        box-sizing: border-box;
    }

	.board {
		position: relative;
		font-size: calc(var(--height) / 25.0625); // Base 16px for sizing
		color: black;
	}
	.mission-container {
		position: absolute;
		flex-direction: row;
		gap: calc(var(--height) / 40.1); //10px;
		width: calc(var(--height) / 0.5347); //750px;
		height: calc(var(--height) / 1.823); // 220px;
		left: 18%;
		top: 4.5%;
	}
	.special-container {
		position: absolute;
		width: calc(var(--height) / 0.668); //600px;
		height: calc(var(--height) / 15.423); //26px;
		left: 23%;
		top: 29%;
		align-items: center;
	}
	.glow-label {
		position: absolute;
		color: azure;
		//text-shadow: 0 0  6px lightgrey;
		text-shadow: 0 0  calc(var(--height) / 66.833) lightgrey;
	}
	.side-label {
		font-size: calc(var(--height) / 22.278); //18px;
		width: calc(var(--height) / 2.005); // 200px;
		justify-content: center;
		transform: rotate(90deg);
		transform-origin: 100%;
		right: 2.25%;
		top: 28%;
	}
	.deck-label {
		font-size: calc(var(--height) / 16.708); //24px;
		top: 33.75%;
		left: 50%;
		transform: translate(-50%, 0);
	}
	img.board-bg {
		max-width: calc(var(--height) / 0.401); //1000px;
	}

	

</style>
